import React, { useContext, useEffect, useState } from "react";
import cx from "classnames";
import { AppFormControllerContext } from "../providers/AppFormProvider";
import { PageType } from "../enums/PageType";
import { getSidebarInfo } from "../api/ApiAppForm";
import AFSidebarPageRow from "./AFSidebarPageRow";
import { IPageInfo } from "../interfaces/IAppFormData";


type SidebarParams = {
    currentPage: IPageInfo
};

const AFSidebar: React.FC<SidebarParams> = ({ currentPage }) => {
    const { selectors } = useContext(AppFormControllerContext);
    const [isOpenViewBreakdownModal, setIsOpenViewBreakdownModal] = useState(false);
    const [productNames, setProductNames] = useState("");

    const currentPageType = currentPage.pageType;
    const applicants = selectors.getApplicantList();
    const adults = applicants.filter(a => !a.isChild);

    const applicationId = selectors.getApplicationId();
    const groupId = selectors.getQuoteGroupId();

    useEffect(() => {
        getSidebarInfo(applicationId, groupId)
            .then((res) => {
                const productNames = res.productTypeNames.join(", ");
                setProductNames(productNames);
            });
    }, [applicationId, groupId]);

    return (
        <div className={cx("panel-green-lt")}>
            {/*<ViewBreakdownModal*/}
            {/*    isOpen={isOpenViewBreakdownModal}*/}
            {/*    onClose={() => setIsOpenViewBreakdownModal(false)}*/}
            {/*    settings={card.result.settings}*/}
            {/*    card={card}*/}
            {/*    clients={clients}      card?: IQuoteCardResult; quoteClients?: IClient[];*/}
            {/*/>*/}
            <div className={cx("layout-panel-sidebar")}>
                    <h3 className={cx("gap-xs")}>{selectors.getInsurerName()} - {productNames} insurance</h3>
                {/*<a className="text-breakdown-link"*/}
                {/*    onClick={() => setIsOpenViewBreakdownModal(true)}>*/}
                {/*    View price breakdown*/}
                {/*</a>*/}
            </div>
            <AFSidebarPageRow
                currentPage={currentPage}
                isActive={() => currentPageType === PageType.Personal || currentPageType === PageType.Contact}
                lastApplicablePage={PageType.Contact}
                text={"Personal details"}
                applicants={applicants} />
            <AFSidebarPageRow
                currentPage={currentPage}
                isActive={() => currentPageType === PageType.AppForm}
                lastApplicablePage={PageType.AppForm}
                text={"Insurer questions"}
                applicants={applicants} />
            <AFSidebarPageRow
                currentPage={currentPage}
                isActive={() => currentPageType === PageType.Declarations}
                lastApplicablePage={PageType.Declarations}
                text={"Declarations"}
                applicants={[]} />
            <AFSidebarPageRow
                currentPage={currentPage}
                isActive={() => currentPageType === PageType.Payment}
                lastApplicablePage={PageType.Payment}
                text={"Payment options"}
                applicants={[]} />
            {/*<AFSidebarPageRow*/}
            {/*    currentPage={currentPage}*/}
            {/*    isActive={() => currentPageType === PageType.Address}*/}
            {/*    lastApplicablePage={PageType.Address}*/}
            {/*    text={"Address"}*/}
            {/*    applicants={adults} />*/}
            <AFSidebarPageRow
                currentPage={currentPage}
                isActive={() => currentPageType === PageType.Consent}
                lastApplicablePage={PageType.Consent}
                text={"Consent"}
                applicants={[]} />
            {/*<AFSidebarPageRow
                currentPage={currentPage}
                lastApplicablePage={PageType.Signature}
                text={"Signature"}
                applicants={applicants} />*/}
            <AFSidebarPageRow
                currentPage={currentPage}
                isActive={() => currentPageType === PageType.Submit}
                lastApplicablePage={PageType.Submit}
                text={"Submit"}
                applicants={[]} />
        </div>
    );
};

export default AFSidebar;
